<div class="container-fluid">
    <br><br>
    <div class="row">
        <div class="col-lg-3">
            <img src="assets/img/auri.png" height="120px">
        </div>
        <div class="col-lg-6">
            <ul class="nav nav-pills">
                <li class="nav-item" >
                <a class="nav-link" id="paqueteNav" routerLink="/perfil">Mi Paquete</a>
                </li>
                <li class="nav-item" >
                <a class="nav-link" id="datosNav" routerLink="/perfil/datos">Mis Datos</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pagosNav" routerLink="/perfil/pagos">Mis Pagos</a>
                </li>
                <li class="nav-item">
                <a class="nav-link" id="grupoNav" routerLink="/perfil/grupo">Mi Grupo</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" id="fotosNav" routerLink="/perfil/fotos">Mis Fotos</a>
                    </li>

                <li class="nav-item">
                    <button class="fondoAmarillo blanco bold" style="border:0px; margin-top:5px;" (click)="redirigirAPagos();">Realizar Pago</button>
                </li>
            </ul>
        </div>
        <div class="col-lg-2">
            <p>¡Hola, <strong>{{datosCliente.nombre}}</strong>!<br>
            <a class="amarillo" (click)="closeSesion()">Cerrar Sesión</a></p>
        </div>
    </div>
</div>
